import React, { Component } from 'react';
import { serviceConstants } from '../../../services/common/constants';
import { getUserAuthToken } from '../../../services/common/util';

export default class ResultPdfRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdfPath:
                props.data && props.data.results && props.data.results.pdf_path
                    ? `${serviceConstants.API_HOST_NAME}${props.data.results.pdf_path}`
                    : ''
        };
    }

    render() {
        return (
            <div>
                {this.state.pdfPath.length > 0 ? (
                    <a
                        href={this.state.pdfPath + '?' + new Date().getTime() + '&token=' + getUserAuthToken()}
                        target="_blank"
                        rel="noreferrer"
                        className="pdf-link"
                    >
                        <i className="fa fa-file-pdf-o"></i>{' '}
                        {this.props.data.results.pdf_path.replace('/files/resultPDF/', '')}
                    </a>
                ) : (
                    <div></div>
                )}
            </div>
        );
    }
}
